import { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { successAlert, errorAlert } from '../utils/Alerts';

function CreateThemes({ token, theme, isLoggedIn }) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    contentTypes: [],
    permissions: []
  });
  const [themes, setThemes] = useState([]);
  const [processing, setProcessing] = useState(false);
  // const [categories, setCategories] = useState([]);

  const isDark = theme === 'dark';
  const navigate = useNavigate();

  // ── Redirige al login si no hay sesión ──

  // useEffect(() => {
  //   const fetchCategories = async () => {
  //     try {
  //       const categoriesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/categories`, {
  //         headers: { Authorization: `Bearer ${token}` }
  //       });
  //       setCategories(categoriesResponse.data);
  //     } catch (error) {
  //       console.error('Error al cargar categorías:', error);
  //     }
  //   };
  //   fetchCategories();
  // }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    try {
      const existingTheme = themes.find(t => t.name.toLowerCase() === formData.name.toLowerCase());
      if (existingTheme) {
        errorAlert({ title: 'Duplicado', text: 'La temática ya existe' });
        setProcessing(false);
        return;
      }

      const preparedData = {
        name: formData.name,
        description: formData.description,
        contentTypes: formData.contentTypes,
        permissions: formData.permissions.map(p => ({
          category: p.category,
          read: p.read,
          write: p.write
        }))
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/admin/themes`,
        preparedData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setThemes(prev => [...prev, response.data]);

      successAlert({
        text: response.data.message || '¡Temática creada correctamente!',
        timer: 2000,
      }).then(() => {
        navigate('/dashboard', { replace: true });
      });

      setFormData({ name: '', description: '', contentTypes: [], permissions: [] });

    } catch (error) {
      console.error('Error al crear temática:', error);

      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.details ||
        'Hubo un error al crear la temática';

      errorAlert({
        title: 'Error',
        text: backendMessage,
      });
    } finally {
      setProcessing(false);
    }
  };

  return (
    <PageWrapper id="dashboard-content" active={isDark}>
      <FormCard active={isDark}>
        <FormTitle active={isDark}>Crear Nueva Temática</FormTitle>

        <StyledForm onSubmit={handleSubmit}>
          <InputRow>
            <StyledInput
              active={isDark}
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Nombre de la temática"
              required
              disabled={processing}
            />
            <StyledInput
              active={isDark}
              type="text"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Descripción"
              required
              disabled={processing}
            />
          </InputRow>

          <SubmitButton type="submit" isDarkMode={isDark} disabled={processing}>
            {processing ? 'Guardando...' : 'Guardar Temática'}
          </SubmitButton>
        </StyledForm>

        {/* ── Permisos de Contenidos COMENTADOS ──
        <Section active={isDark}>
          <SectionTitle active={isDark}>Permisos de Contenidos</SectionTitle>
          <CheckRow>
            {['images', 'videos', 'texts'].map((type) => (
              <CheckLabel key={type} active={isDark}>
                <input
                  type="checkbox"
                  checked={formData.contentTypes.includes(type)}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setFormData(prev => ({
                      ...prev,
                      contentTypes: isChecked
                        ? [...prev.contentTypes, type]
                        : prev.contentTypes.filter(t => t !== type)
                    }));
                  }}
                />
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </CheckLabel>
            ))}
          </CheckRow>
        </Section>

        <Section active={isDark}>
          <SectionTitle active={isDark}>Acceso por Categoría</SectionTitle>
          <AddButton type="button" onClick={() =>
            setFormData(prev => ({
              ...prev,
              permissions: [...prev.permissions, { category: '', read: false, write: false }]
            }))
          }>
            + Agregar Permiso
          </AddButton>

          {formData.permissions.map((permission, index) => (
            <PermissionRow key={index} active={isDark}>
              <StyledSelect
                active={isDark}
                value={permission.category}
                onChange={(e) => {
                  const val = e.target.value;
                  setFormData(prev => {
                    const updated = [...prev.permissions];
                    updated[index].category = val;
                    return { ...prev, permissions: updated };
                  });
                }}
              >
                <option value="">Seleccione categoría</option>
                {categories.map(cat => (
                  <option key={cat._id} value={cat._id}>{cat.name}</option>
                ))}
              </StyledSelect>

              <CheckLabel active={isDark}>
                <input
                  type="checkbox"
                  checked={permission.read}
                  onChange={(e) => {
                    const updated = [...formData.permissions];
                    updated[index].read = e.target.checked;
                    setFormData(prev => ({ ...prev, permissions: updated }));
                  }}
                />
                Leer
              </CheckLabel>

              <CheckLabel active={isDark}>
                <input
                  type="checkbox"
                  checked={permission.write}
                  onChange={(e) => {
                    const updated = [...formData.permissions];
                    updated[index].write = e.target.checked;
                    setFormData(prev => ({ ...prev, permissions: updated }));
                  }}
                />
                Escribir
              </CheckLabel>

              <RemoveButton type="button" onClick={() =>
                setFormData(prev => ({
                  ...prev,
                  permissions: prev.permissions.filter((_, i) => i !== index)
                }))
              }>
                Eliminar
              </RemoveButton>
            </PermissionRow>
          ))}
        </Section>
        ── Fin Permisos Comentados ── */}

      </FormCard>
    </PageWrapper>
  );
}

/* ─── Styled Components ─── */

const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
  padding: 20px;
`;

const FormCard = styled.div`
  background-color: ${props => props.active ? '#1e1e1e' : '#ffffff'};
  border: 1px solid ${props => props.active ? '#333' : '#e0e0e0'};
  border-radius: 12px;
  padding: 40px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 8px 32px ${props => props.active ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.1)'};
  transition: background-color 0.3s ease;
`;

const FormTitle = styled.h2`
  text-align: center;
  margin-bottom: 30px;
  font-size: 1.5rem;
  font-weight: 600;
  color: ${props => props.active ? '#ffffff' : '#222'};
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InputRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StyledInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  background-color: ${props => props.active ? '#2a2a2a' : '#f5f5f5'};
  border: 1px solid ${props => props.active ? '#3d3d3d' : '#ddd'};
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 15px;
  color: ${props => props.active ? '#e0e0e0' : '#333'};
  transition: all 0.3s ease;
  outline: none;

  &::placeholder {
    color: ${props => props.active ? '#666' : '#aaa'};
  }

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 2px ${props => props.active ? 'rgba(0,123,255,0.2)' : 'rgba(0,123,255,0.1)'};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  background-color: ${props => props.isDarkMode ? '#000000' : '#282d32'};
  color: #ffffff;
  padding: 14px;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  margin-top: 4px;
  transition: all 0.3s ease;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: ${props => props.isDarkMode ? '#363636' : '#1a1a1a'};
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;

// ── Styled components de permisos comentados ──
// const Section = styled.div`
//   margin-top: 24px;
//   padding-top: 20px;
//   border-top: 1px solid ${props => props.active ? '#333' : '#e0e0e0'};
// `;

// const SectionTitle = styled.h3`
//   font-size: 14px;
//   font-weight: 600;
//   color: ${props => props.active ? '#aaa' : '#666'};
//   text-transform: uppercase;
//   letter-spacing: 1px;
//   margin-bottom: 14px;
// `;

// const CheckRow = styled.div`
//   display: flex;
//   gap: 20px;
//   flex-wrap: wrap;
// `;

// const CheckLabel = styled.label`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   font-size: 14px;
//   color: ${props => props.active ? '#ccc' : '#555'};
//   cursor: pointer;
// `;

// const AddButton = styled.button`
//   background: transparent;
//   border: 1px dashed #007bff;
//   color: #007bff;
//   padding: 7px 14px;
//   border-radius: 6px;
//   font-size: 13px;
//   cursor: pointer;
//   margin-bottom: 12px;
//   transition: all 0.2s;
//   &:hover { background: rgba(0,123,255,0.08); }
// `;

// const PermissionRow = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   flex-wrap: wrap;
//   background: ${props => props.active ? '#2a2a2a' : '#f9f9f9'};
//   border: 1px solid ${props => props.active ? '#3d3d3d' : '#e0e0e0'};
//   border-radius: 8px;
//   padding: 10px 14px;
//   margin-bottom: 10px;
// `;

// const StyledSelect = styled.select`
//   background-color: ${props => props.active ? '#333' : '#fff'};
//   border: 1px solid ${props => props.active ? '#555' : '#ddd'};
//   border-radius: 6px;
//   padding: 7px 10px;
//   color: ${props => props.active ? '#e0e0e0' : '#333'};
//   font-size: 14px;
//   outline: none;
//   flex: 1;
// `;

// const RemoveButton = styled.button`
//   background: rgba(220,53,69,0.1);
//   border: 1px solid rgba(220,53,69,0.3);
//   color: #dc3545;
//   padding: 6px 12px;
//   border-radius: 6px;
//   font-size: 13px;
//   cursor: pointer;
//   transition: all 0.2s;
//   &:hover { background: rgba(220,53,69,0.2); }
// `;

export default CreateThemes;